import { ArrowDownRight, ArrowUpRight, FileText, Orbit, Sparkles } from "lucide-react"
import "./styles.css"

type ToolStatus = "available" | "preparing"

interface ToolItem {
  number: string
  title: string
  description: string
  href?: string
  status: ToolStatus
  icon: typeof FileText
}

const tools: ToolItem[] = [
  {
    number: "01",
    title: "链接转 Markdown",
    description: "把网页内容整理为清爽、可编辑、方便长期保存的 Markdown。",
    status: "preparing",
    icon: FileText,
  },
  {
    number: "02",
    title: "个人工作工具",
    description: "围绕内容、报告与日常工作的轻量工具，将从这里陆续上线。",
    status: "preparing",
    icon: Orbit,
  },
]

function ToolLink({ tool }: { tool: ToolItem }) {
  const Icon = tool.icon
  const content = (
    <>
      <span className="tool-number">{tool.number}</span>
      <span className="tool-icon" aria-hidden="true"><Icon size={22} strokeWidth={1.5} /></span>
      <span className="tool-copy">
        <strong>{tool.title}</strong>
        <span>{tool.description}</span>
      </span>
      <span className={`tool-status tool-status--${tool.status}`}>
        {tool.status === "available" ? "立即使用" : "准备中"}
      </span>
      <ArrowUpRight className="tool-arrow" size={22} strokeWidth={1.5} aria-hidden="true" />
    </>
  )

  return tool.href ? (
    <a className="tool-row" href={tool.href}>{content}</a>
  ) : (
    <div className="tool-row tool-row--inactive">{content}</div>
  )
}

export default function App() {
  return (
    <main>
      <header className="site-header">
        <a className="wordmark" href="#top" aria-label="返回首页">MAGUS CHOW</a>
        <nav aria-label="页面导航">
          <a href="#tools">工具</a>
          <a href="#about">关于</a>
        </nav>
      </header>

      <section className="hero" id="top">
        <p className="hero-kicker"><Sparkles size={15} strokeWidth={1.6} aria-hidden="true" /> Useful things, made carefully.</p>
        <h1>把真正有用的<br /><em>小工具</em>放在一起。</h1>
        <p className="hero-intro">这里会慢慢长成一个轻量、可靠的工具入口。没有复杂的功能堆叠，只解决那些值得反复解决的问题。</p>
        <a className="hero-jump" href="#tools">
          查看工具
          <ArrowDownRight size={18} strokeWidth={1.5} aria-hidden="true" />
        </a>
        <div className="hero-mark" aria-hidden="true">M·C</div>
      </section>

      <section className="tool-section" id="tools">
        <div className="section-label">
          <span>INDEX / 001</span>
          <h2>工具索引</h2>
        </div>
        <div className="tool-list">
          {tools.map((tool) => <ToolLink key={tool.number} tool={tool} />)}
        </div>
      </section>

      <section className="about" id="about">
        <p className="about-index">A NOTE FROM THE MAKER</p>
        <div className="about-copy">
          <h2>工具不必庞大，<br />但应该让事情变得更轻。</h2>
          <p>这个网站用于发布我在真实工作中反复使用的工具。每个工具都会尽量保持边界清楚、数据透明，并在上线前经过实际验证。</p>
        </div>
      </section>

      <footer>
        <span>© {new Date().getFullYear()} Magus Chow</span>
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
          粤ICP备2026124162号
        </a>
      </footer>
    </main>
  )
}
